
import { mapMutations, mapState } from "vuex";
import MenuOrderBackToWhatsappDialog from "../../components/dialogs/menu-order-back-to-whatsapp-dialog.vue";
import OrderSummary from "../../components/cart/order-summary.vue";
export default {
  layout: "withBackButtonAndTitle",
  components: {
    MenuOrderBackToWhatsappDialog,
    OrderSummary
  },
  beforeMount() {
    this.SET_PAGE_TITLE("My Cart");
  },
  data() {
    return {
      showBackToWhatsappDialog: false
    };
  },
  computed: {
    ...mapState("order", ["restaurantDetails", "cart"])
  },
  methods: {
    ...mapMutations("misc", ["SET_PAGE_TITLE"])
  }
};
